<template>
  <div class="flex flex-wrap -mb-8 -mr-6 p-8">
    <text-input v-model="form.date_imprisonment" required :date-not-in-future="true" :type="'date'" :error="form.errors.date_imprisonment" class="pb-8 pr-6 w-full lg:w-1/2" :label="$t('situationcases.date_imprisonment')" />
    <select-dropdown v-model="form.location_id" :error="form.errors.location_id" class="pr-6 pb-8 w-full lg:w-1/2" :options="locations" :label="$t('situationcases.location')" />
    <textarea-input v-model="form.reason_imprisonment" required :error="form.errors.reason_imprisonment" class="pb-8 pr-6 w-full lg:w-2/2" :label="$t('situationcases.reason_imprisonment')" rows="4" />
    <checkbox
      v-model="form.interned" :error="form.errors.interned" class="pb-8 pr-6 w-full lg:w-1/6"
      :label="$t('situationcases.interned')"
    />
  </div>
</template>
<script>
import TextInput from '@/Shared/TextInput'
import TextareaInput from '@/Shared/TextareaInput'
import SelectDropdown from '@/Shared/SelectDropdown'
import Checkbox from '@/Shared/Checkbox'

export default {
  components: {
    TextInput,
    TextareaInput,
    SelectDropdown,
    Checkbox,
  },
  props: ['formData','locations'],
  computed: {
    form() {
      return this.formData
    },
  },
}
</script>
